import { laborHoursConstant } from 'src/redux/actions/constant';

const intitialstate: object = {
  response: null,
  isLaborHours: false,
  loading: false,
};

export const getLaborHoursReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case laborHoursConstant.GET_LABOR_HOURS_SUCCESS: {
      return {
        ...state,
        isLaborHours: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case laborHoursConstant.GET_LABOR_HOURS_FAILURE:
      return {
        ...state,
        isLaborHours: false,
        response: action.payload,
        loading: false,
      };

    case laborHoursConstant.GET_LABOR_HOURS_LOADER:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
